<!-- <ion-header *ngIf="!platformSRV.isNative.value"> -->
  <!-- <ion-toolbar class="login_background" >
    <ion-item lines="none" style="text-align: center;" button>
      <ion-label>Click here to go back back to the older version</ion-label>
     
    </ion-item>
    </ion-toolbar> -->
<!-- </ion-header> -->
<ion-content >
  <div *ngIf="platformSRV.isNative.value" class="add-margin-top-to-safe-area"></div>

  <app-header-content ></app-header-content>
  

  <ion-grid class="page-min-height" >
    <ion-row *ngIf="dataService.settings['global']">
      <ion-col sizeSm="10" offsetSm="1" sizeMd="8" offsetMd="2" sizeLg="6" offsetLg="3" style="text-align:center ;">
        <img class="logo-max" *ngIf="(dataService.settings['global']['default_logo_url'] | json)!='{}'"  [src]="dataService.settings['global']['default_logo_url']">
         
      </ion-col>
    </ion-row>
    <ion-row >
     
      <ion-col    [ngClass]="{'single-col': isContentEmpty, 'fixed-half-col': !isContentEmpty}">

      
      <form [formGroup]="loginForm" >
      <ion-grid *ngIf="dataService.settings">
        <ion-row>
          <ion-col style="text-align: center;">
            <h2 class="header-regular"
                  
                  >{{('keys.data.auth.welcome' | translate : {Default:'Welcome'}) || 'Welcome'}}</h2
                >
          </ion-col>
        </ion-row>
        <ion-row *ngIf="authSetting">
          <ion-col size="12"   *ngFor="let loginSource of authSetting['providers']['users']['login_by_redirect']">
            <ion-button (click)="openLoginSource(loginSource)"  style="--border-radius: 0.5em; margin-bottom: 1em"
            color="primary"
            type="submit"
            expand="block"*ngIf="loginSource.visible"  >
            {{('keys.data.'+ loginSource['label_code'] | translate : {Default: loginSource['label']}) || loginSource['label']
                }}
    
            </ion-button>
            
          </ion-col>
        </ion-row>
        <ion-row *ngIf="authSetting && authSetting?.providers?.users?.login_by_redirect.length>0 && dataService.allowOpsComLogin">
          <ion-col size="12">
            <div class="line-container">
              <span class="line-text">OR</span>
            </div>
          </ion-col>
          
        </ion-row>
        <div *ngIf="dataService.allowOpsComLogin">
        <ion-row >
          <ion-col class="ion-no-padding" >
                <ion-card class="card-shadow-3">
                  <ion-item lines="none" class="paragraph-input-fields-regular">
                    <ion-icon
                      src="assets/person.svg"
                      style="color: black;font-size: large;"
                      *ngIf="typingUsername"
                    ></ion-icon>
                    <ion-icon
                      src="assets/mail.svg"
                      style="color: black;font-size: large;"
                      *ngIf="typingEmail"
                    ></ion-icon>
                    <ion-input
                    (keyup.enter)="submitOnEnter()"
                      style="margin-left: 0.5em;"
                      formControlName="login"
                      required
                      class="secondary-text"
                      type="text"
                     
                      [placeholder]="('keys.data.users_login.username_or_email' | translate : {Default:'Username or Email'}) ||
                      'Username or Email'"
                      (ionChange)="enableLogin()"
                    ></ion-input>
                  </ion-item>
                </ion-card>
                 
               
              
          </ion-col>
        </ion-row>
        
        <ion-row>
          <ion-col class="ion-no-padding" >
            <ion-card class="card-shadow-3">
            <ion-item lines="none" class="paragraph-input-fields-regular">
              <ion-icon
                style="color: black;font-size: large;"
                *ngIf="typingPassword"
                name="lock-open"
              ></ion-icon>
              <ion-input
                (keyup.enter)="submitOnEnter()"
                formControlName="password"
                required
                class="secondary-text"
                type="password"
                style="margin-left: 0.5em;"
                [placeholder]="('keys.data.auth.password' | translate : {Default:'Password'}) ||
                'Password'"
                (ionChange)="enableLogin()"
              ></ion-input>
            </ion-item>
          </ion-card>
          </ion-col>
        </ion-row>
        
        <ion-row *ngIf="errors.length>0">
          <ion-col>
            <ion-card class="error_box card-shadow-3" >
              <ion-card-content >
                <ion-row>
                <ion-col class="ion-no-padding" style="text-align: center;"  *ngFor="let error of errors" size="12">
                  <ion-label color="primary" class="card-text-bold">{{error}}</ion-label>
                </ion-col>
              </ion-row>
            </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col  style="padding-top: 0;" >
              <ion-label   class="ion-text-left" routerLink="/forgotpassword" 
              color="primary"
              style="cursor: pointer;margin: 0;" class="card-text-bold"
            >
            {{('keys.data.users_login.forgot_password_title' | translate : {Default:'Forgot Password?'}) || 'Forgot Password?'}}
            </ion-label>            
          </ion-col>
        </ion-row>
        <ion-row>
         
        </ion-row>
        <ion-row style="border-bottom: 1px solid  rgba(0, 0, 0, 0.153);">
          <ion-col size="12">
            <ion-button 
            
                  (click)="onLogin()"
                  style="--border-radius: 0.5em; margin-bottom: 1em"
                  color="primary"
                  type="submit"
                  expand="block"
                  [disabled]="!loginForm.valid"
                >
                  {{('keys.data.auth.login' | translate : {Default:'login'}) || 'login'}}
                </ion-button>
          </ion-col>
        </ion-row>
        </div>
        <ion-row *ngIf="dataService.settings?.userProfile?.enablePublicRegistration">
          <ion-col >
            <ion-button 
            
            routerLink="/register"
            style="--border-radius: 0.5em;"
            color="primary"
            type="submit"
            expand="block"
          >
          {{('keys.data.users_login.create_account' | translate :
                {Default:'create account'}) || 'create account'}}
          </ion-button>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="dataService.isEnabled(dataService.settings?.violations?.appeals_enabled) 
                || dataService.isEnabled(dataService.settings?.payments?.isGuestPaymentEnabled)">
          <ion-col size="12" >
            <ion-button 
            
            (click)="lookupTicket()" 
            style="--border-radius: 0.5em;"
            color="primary"
            type="submit"
            expand="block"
          >
          {{('keys.data.violations.pay_your_ticket' | translate : {Default:'Pay Ticket'}) ||
                'Pay Ticket'}}
          </ion-button>
            
          </ion-col>
        </ion-row>
       
        <ion-row *ngIf="dataService.selectedClient && dataService.isProductionBuild">
          <ion-col size="12" style="text-align: center">
            <ion-chip style=" --background: var(--Orange-Pastel, #FFE6D5)"  >{{("keys.data.users_login.connected_to" | translate : {Default:"Connected to"}) || "Connected to"}}: <span style="font-weight: bold">{{dataService.selectedClient['clientName']}}</span>  </ion-chip>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="dataService.selectedClient && !dataService.isProductionBuild">
            <ion-col   style="text-align: center">
            <ion-chip style=" --background: var(--Orange-Pastel, #FFE6D5)"  >{{("keys.data.users_login.connected_to" | translate : {Default:"Connected to"}) || "Connected to"}}: <span style="font-weight: bold">{{dataService.selectedClient['webUrl']}}</span>  </ion-chip>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="dataService.selectedClient">
          <ion-col size="12">
            <ion-item button (click)="changeClient()" lines="none" class="paragraph-regular" >
              <ion-label  class="ion-text-wrap ion-no-margin" 
              style="cursor: pointer;" >
              {{("keys.data.users_login.connect_to_different_provider" | translate : {Default:"Connect to a different provider?"}) || "Connect to a different provider?"}}
              </ion-label>
              <span class="ion-text-right button-clear"  color="primary"
              style="cursor: pointer;" >
              {{("keys.data.config.change_provider" | translate : {Default:"Change Provider"}) || "Change Provider"}}
              </span>
            </ion-item>
          </ion-col>
         
        </ion-row>
       
        <ion-row *ngIf="dataService.settings['temp_permits']?.['enable_qr_codes']=='1' && platformSRV.isNative.value"  >
          <ion-col size="12">
            <ion-item (click)="openScanner()" lines="none"   >
              <ion-label class="button-clear" color="primary" style="cursor: pointer;margin: 0;">
                {{("keys.data.permits.scan_qr" | translate : {Default:"Scan QR code"}) || "Scan QR code"}}
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="dataService.settings['temp_permits']?.['enable_real_time_map']=='1'">
          <ion-col size="12"  >
            
            <ion-button   (click)="openRealTimeParking()" expand="block" color="primary"><ion-icon name="location-sharp"></ion-icon> <ion-label>
              {{('keys.data.permits.parking_map' | translate) || 'Parking Map'}}</ion-label
           ></ion-button>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="platformSRV.isNative.value==false && dataService.settings.userProfile?.phoneAppPromptDisplay">
          <ion-col  size="12">
            <ion-button  expand="block" (click)="dataService.redirectToStoreOrShowQr()" color="primary">
              <ion-icon name="qr-code" ></ion-icon>
                {{("keys.data.users_menu.get_app" | translate : {Default:"Get App"}) || "Get App"}}
            </ion-button>
          </ion-col>
        </ion-row>
        
        
        
      </ion-grid>
       </form>
      </ion-col>
      <ion-col [hidden]="isContentEmpty" class="half-col"
        style="padding: 0.5em;padding:15px ;" >
        <app-pagecontent [path]="'ionic-login'" #pagecontent></app-pagecontent>
      </ion-col>
    </ion-row>
    
  </ion-grid>
  <ion-footer class="ion-no-border">
    <app-footer></app-footer>
  </ion-footer>
</ion-content>
